<div *ngIf="displayFromTrustFields && transferType !== 'positions'">
  <sdps-divider variation="secondary"></sdps-divider>
  <span id="section-title">Source account PTRS elections</span>
  <div class="row" *ngIf="noPaidFor">
    <div class="sdps-messaging warning-container" id="trust-paid-for-warning">
      <span class="sdps-messaging__icon warning sch-exclamation-triangle-2x"></span>
      <div class="sdps-messaging__text">
        <span class="sdps-messaging__title">"Paid For" choices are currently unavailable. This transaction will be
          created with "Paid For" of the trust itself. </span>
        <span  class="sdps-messaging__Description">"Paid For" information can
          be updated via the
          <a (click)="getDrupalPdf('PTRS-adjustment-form')" target="_blank">PTRS Adjustment
            Form</a>.
        </span>
        
      </div>
    </div>
  </div>
  <div class="trust-fields-container">
    <div class="trust-source-account">
      <mm-trust-income-principal [parentForm]="parentForm" [availableCash]="availableCash"
        [datePickerControlName]="datePickerControlName" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
        [incomePercent$]="trustIncomePercent$" [principalPercent$]="trustPrincipalPercent$" [ptrsInfo$]="ptrsInfo$"
        [component]="'source'" [shouldStyleHorizontal]="true" [isEdit]="isEdit" [isFromAccount]="true" class="big-bottom-spacer">
      </mm-trust-income-principal>
      <div class="alignMultipleTrustSections">
        <mm-trust-tax-category id="trust-tax-category" [parentForm]="parentForm" [taxCategories]="taxCategories$"
          class="big-bottom-spacer">
        </mm-trust-tax-category>
      </div>
      <div class="alignMultipleTrustSections">
        <mm-trust-tax-code id="trust-tax-code" [parentForm]="parentForm" [codes]="taxCodes$" class="big-bottom-spacer">
        </mm-trust-tax-code>
      </div>
      <div class="alignMultipleTrustSections">
        <mm-trust-paid-for id="trust-paid-for" [parentForm]="parentForm" class="big-bottom-spacer"
          [shouldStyleHorizontal]=true>
        </mm-trust-paid-for>
      </div>
      <div class="alignMultipleTrustSections">
        <mm-trust-comment id="trust-comment" [parentForm]="parentForm" class="big-bottom-spacer"></mm-trust-comment>
      </div>
    </div>
  </div>
</div>
<div *ngIf="displayToTrustFields && transferType !== 'positions'" [ngClass]="['container', 'big-bottom-spacer']">
  <mm-trust-income-principal [parentForm]="parentForm" [availableCash]="availableCash"
    [datePickerControlName]="datePickerControlName" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
    [incomePercent$]="trustIncomeToPercent$" [isEdit]="isEdit" [principalPercent$]="trustPrincipalToPercent$" [ptrsInfo$]="ptrsInfo$"
    [component]="'receiving'" [isFromAccount]="false" [shouldStyleHorizontal]="true">
  </mm-trust-income-principal>
  <div class="alignMultipleTrustSections">
    <mm-trust-deposit-code id="trust-deposit-code" [parentForm]="parentForm">
    </mm-trust-deposit-code>
  </div>
</div>